import { render, staticRenderFns } from "./FirebaseRedirect.vue?vue&type=template&id=3fe3a9a8&"
import script from "./FirebaseRedirect.vue?vue&type=script&lang=js&"
export * from "./FirebaseRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe3a9a8')) {
      api.createRecord('3fe3a9a8', component.options)
    } else {
      api.reload('3fe3a9a8', component.options)
    }
    module.hot.accept("./FirebaseRedirect.vue?vue&type=template&id=3fe3a9a8&", function () {
      api.rerender('3fe3a9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/FirebaseRedirect.vue"
export default component.exports